<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="purchaseReceives"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary">打印条码</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search" style="width: auto;">
          <vm-search label="编号">
            <el-input v-model.trim="filter.no" style="width: 170px" clearable/>
          </vm-search>
          <vm-search label="采购订单号">
            <el-input v-model.trim="filter.purchaseOrderNO" style="width: 170px" clearable/>
          </vm-search>
          <vm-search label="状态">
            <el-select v-model.trim="filter.status" style="width: 170px" clearable placeholder="请选择">
              <el-option
                  v-for="item in statu"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="到货状态">
            <el-select v-model.trim="filter.receiveStatus" style="width: 170px" clearable placeholder="请选择">
              <el-option
                  v-for="item in receiveStatu"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="预计到货时间" style="margin-right: 2.5%">
            <div class="block">
              <el-date-picker
                  v-model="filter.planAddDateBegin"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 140px;"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.planAddDateEnd"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 178px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
          <vm-search label="实际到货时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.actualDateBegin"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 140px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.actualDateEnd"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 180px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
          <vm-search label="创建人">
            <el-input v-model.trim="filter.creatorName" style="width: 170px" clearable/>
          </vm-search>
          <vm-search label="供应商">
            <el-input v-model.trim="filter.gysName" style="width: 170px" clearable/>
          </vm-search>
          <vm-search label="采购组">
            <el-input v-model.trim="filter.buyUserName" style="width: 170px" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="40"/>
      <el-table-column
          prop="no"
          align="center"
          label="编号"
          width="115">
        <template slot-scope="scope">
          <span
              style="color: #2d8cf0;cursor: pointer;"
              @click="$refs.preview.open(scope.row.pkid,'index')">
            {{scope.row.no}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="purchaseOrderNO" align="center" label="采购订单号" width="90"/>
      <el-table-column prop="status" align="center" label="状态" width="60">
        <template slot-scope="scope">
          <span v-if="scope.row.status===98" style="color: red">
            {{constant.purchaseStatus[scope.row.status]}}
          </span>
          <span v-else>
            {{constant.purchaseStatus[scope.row.status]}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" align="center" label="收货单创建时间"/>
      <el-table-column prop="gysName" align="center" label="供应商"/>
      <el-table-column prop="buyUserName" align="center" label="采购组" width="60"/>
      <el-table-column prop="plannedArrivalTime" align="center" label="要求到货日期">
        <template slot-scope="scope">
          <p v-if="scope.row.isUrgent===1">
            {{scope.row.isSuspended === -1? "暂停":scope.row.plannedArrivalTime +"/"}}
            <span style="color: red">
              {{scope.row.urgentArrivalDate}}
            </span>
          </p>
          <p v-else>
            {{scope.row.isSuspended === -1? "暂停":scope.row.plannedArrivalTime}}
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="arrivedTime" align="center" label="实际到货日期"/>
      <el-table-column prop="creatorName" align="center" label="创建人" width="60"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="170px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status === 0 || scope.row.status === 98" type="primary" @click="$refs.editPurchaseReceives.open(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status === 0 || scope.row.status === 15 || scope.row.status === 30 || scope.row.status === 40 || scope.row.status === 45 || scope.row.status === 98" type="primary" @click="submit(scope.row)">提交</el-button>
          <el-button v-if="scope.row.status === 10" type="primary" @click="submit(scope.row)">审核</el-button>
          <el-button v-if="scope.row.status === 15" type="primary" @click="reverseAudit(scope.row)">反审核</el-button>
          <el-button v-if="scope.row.status === 18" type="primary" @click="$refs.editPurchaseReceivesInspectionReportEdit.open(scope.row)">新增报告</el-button>
          <el-button v-if="scope.row.status === 30" type="primary" @click="$refs.editPurchaseReceivesInspectionReportEdit.open(scope.row)">初检</el-button>
          <el-button v-if="scope.row.status === 20" type="primary" @click="$refs.editPurchaseReceives.open(scope.row)">确认收货</el-button>
          <el-button v-if="scope.row.status === 40" type="primary" @click="$refs.editPurchaseReceivesInspectionReportEdit.open(scope.row)">复检</el-button>
          <el-button v-if="scope.row.status === 30" type="danger" @click="inspectionReportDelete(scope.row)">删除检验报告</el-button>
          <el-button v-if="scope.row.status === 45" type="primary" @click="$refs.editPurchaseReceives.open(scope.row)">入库编辑</el-button>
          <el-button v-if="scope.row.status === 10" type="danger" @click="sendBack(scope.row)">退回</el-button>
          <el-button v-if="scope.row.status === 0 || scope.row.status === 98" type="danger" @click="oneDelete(scope.row)">删除</el-button>
          <el-button v-if="scope.row.isSuspended === 1 || scope.row.isSuspended === null" type="info" @click="stop(scope.row)">暂停</el-button>
          <el-button v-if="scope.row.isSuspended === -1" type="info" @click="regain(scope.row)">恢复</el-button>
          <el-button v-if="scope.row.isUrgent!==1" type="danger" @click="$refs.urgent.open(scope.row.pkid)">加急</el-button>
          <el-button v-if="scope.row.isUrgent===1" type="danger">已加急</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <preview ref="preview" @save-success="getList(-1)"/>
    <urgent-time ref="urgent" @save-success="getUrgentTime"/>
    <purchase-receives-edit ref="editPurchaseReceives" @save-success="getList(-1)"/>
    <purchase-receives-inspection-reports-edit ref="editPurchaseReceivesInspectionReportEdit" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";
  import PurchaseReceivesEdit from "@/views/purchase/purchaseReceives/PurchaseReceivesEdit";
  import Preview from "@/views/purchase/purchaseReceives/Preview";
  import UrgentTime from "@/views/purchase/purchaseReceives/urgentTime";
  import PurchaseReceivesInspectionReportsEdit from "@/views/purchase/purchaseReceives/purchaseReceivesInspectionReportsEdit";

  export default {
    name: "PurchaseReceivesList",
    components: {
      PurchaseReceivesInspectionReportsEdit,
      UrgentTime, Preview, PurchaseReceivesEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        statu:constant.toSelect(constant.purchaseStatus,"addAll"),
        receiveStatu:constant.toSelect(constant.receiveStatus),
        show: "",
        pkid: "",
        filter: {
          no: "",
          purchaseOrderNO: "",
          status: -1,
          receiveStatus: "",
          creatorName: "",
          gysName: "",
          buyUserName: "",
          planAddDateBegin: "",
          planAddDateEnd: "",
          actualDateBegin: "",
          actualDateEnd: "",
          urgentArrivalDate: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      //提交
      submit(row) {
        console.log(row.status);
        if(row.status === 0 || row.status === 15 || row.status === 30 || row.status === 40 || row.status === 98) {
          this.$confirm("确定提交该订单吗?", "提示", {type: "info"}).then(() => {
            this.$http
              .get("basic",`purchaseReceives/submitPurchaseStatus/${row.pkid}`).then(() => {
                this.getList(-1);
                this.$message.info("提交成功");
              });
          });
        }
        if(row.status === 10) {
          this.$confirm("确定审核该订单吗?", "提示", {type: "info"}).then(() => {
            this.$http
              .get("basic",`purchaseReceives/submitPurchaseStatus/${row.pkid}`).then(() => {
                this.getList(-1);
                this.$message.info("审核成功");
              });
          });
        }
      },
      //退回
      sendBack(row) {
        this.$confirm("确定退回该订单吗?", "提示", {type: "info"}).then(() => {
          this.$http
            .get("basic",`purchaseReceives/rejectPurchaseReceive/${row.pkid}`).then(() => {
              this.getList(-1);
              this.$message.info("退回成功");
            });
        });
      },

      //反审核
      reverseAudit(row) {
        this.$confirm("确定取消审核该订单吗?", "提示", {type: "info"}).then(() => {
          this.$http
            .get("basic",`purchaseReceives/unReviewPurchaseReceive/${row.pkid}`).then(() => {
              this.getList(-1);
              this.$message.info("取消审核成功");
            });
        });
      },

      //暂停
      stop(row) {
        this.$confirm("确定暂停该订单吗?", "提示", {type: "info"}).then(() => {
          this.$http
            .get("basic",`purchaseReceives/suspendOrder/${row.pkid}`).then(() => {
              this.getList(-1);
              this.$message.info("暂停成功");
            });
        });
      },

      //恢复
      regain(row) {
        this.$confirm("确定恢复该订单吗?", "提示", {type: "info"}).then(() => {
          this.$http
            .get("basic",`purchaseReceives/normalOrder/${row.pkid}`).then(() => {
              this.getList(-1);
              this.$message.info("恢复成功");
            });
        });
      },
      //加急
      getUrgentTime(row) {
        //console.log(row);
        this.$confirm("确定加急该订单吗?", "提示", {type: "info"}).then(() => {
          this.$http
            .get("basic",`purchaseReceives/urgentOrder/${row.pkid}/${row.plannedArrivalTime}`).then(() => {
              this.getList(-1);
              this.$message.info("加急成功");
            });
        });
      },
      //删除检验报告
      inspectionReportDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","inspectionReports",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","purchaseReceives",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
